module.exports = __webpack_public_path__ + "static/media/form.e59f7919.svg";